export default "__VITE_ASSET__f33b9648__"